<!-- <div class="attachmentwrapper">  
  <a target="_blank" href="{{heroconversation.mediaurl}}" *ngFor="let heroconversation of peopleArray">
      <img src="{{heroconversation.mediaurl}}" class="img_test"/>
      <ng-template #nonimage><img src="./assets/preview-unavailable.jpg" height="200" style="display: block;clear: both;"/></ng-template>
  </a>
  </div> -->
  <div class="attachmentwrapper">  
    <div *ngFor="let heroconversation of peopleArray">
      
      <!-- Images -->
      <a *ngIf="heroconversation.mediacontentType.startsWith('image/')" target="_blank" [href]="heroconversation.mediaurl">
        <img [src]="heroconversation.mediaurl" class="img_test" />
      </a>

      <!-- PDFs -->
      <div *ngIf="heroconversation.mediacontentType === 'application/pdf'" class="pdf-media">
        <a target="_blank" [href]="heroconversation.mediaurl">
          <mat-icon class="s-60">picture_as_pdf</mat-icon>
        </a>
      </div>

      <!-- Videos -->
      <div *ngIf="heroconversation.mediacontentType.startsWith('video/')" class="video">
        <video width="200" controls>
          <source [src]="heroconversation.mediaurl" [type]="heroconversation.mediacontentType" />
          Browser not supported
        </video>
      </div>

      <!-- Audios -->
      <div *ngIf="heroconversation.mediacontentType.startsWith('audio/')" class="audio">
        <audio width="200" controls>
          <source [src]="heroconversation.mediaurl" [type]="heroconversation.mediacontentType" />
          Browser not supported
        </audio>
      </div>

      <!-- Other Files -->
      <div *ngIf="!heroconversation.mediacontentType.startsWith('image/') && 
                  heroconversation.mediacontentType !== 'application/pdf' &&
                  !heroconversation.mediacontentType.startsWith('video/') &&
                  !heroconversation.mediacontentType.startsWith('audio/')" 
          class="other-file">
        <a target="_blank" [href]="heroconversation.mediaurl">
          <mat-icon class="s-60">insert_drive_file</mat-icon>
          <span>Download File</span>
        </a>
      </div>

    </div>
</div>
